module.exports = __webpack_public_path__ + "img/paypal.d79f18a8.jpg";